import type Controller from '@ember/controller';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export interface GenieChatThreadArtifactModel {
	artifactId: string;
}

export default class GenieChatThreadArtifactRoute extends Route {
	@service('ai-chat') declare aiChatService: Service.AIChat;

	override model(params: { artifact_id: string }): GenieChatThreadArtifactModel {
		const { artifact_id } = params;
		return { artifactId: artifact_id };
	}

	override setupController(controller: Controller, model: GenieChatThreadArtifactModel): void {
		super.setupController(controller, model);

		// Drive the controlled `artifactId` from the URL into the React mount (hard load + live nav).
		this.aiChatService.applyUrlArtifact(model.artifactId);
	}

	override resetController(_controller: Controller, isExiting: boolean): void {
		// Leaving /artifact/:id (back to the bare thread, or to another route) drops the controlled
		// id, which closes the panel in React.
		if (isExiting) {
			this.aiChatService.applyUrlArtifact(null);
		}
	}
}
